import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { DirectivesModule } from '../../../common/directives/directives.module';

@Component({
  selector: 'ui-simple-text-field',
  imports: [CommonModule, TranslateModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, DirectivesModule],
  templateUrl: './simple-text-field.component.html',
  styleUrls: ['./simple-text-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleTextFieldComponent<T> {
  @Input() textFieldControl: FormControl<T>;
  @Input() fieldLabel: string;
  @Input() testId: string;
  @Input() inputType?: string = 'text';
  @Input() isReadOnly?: boolean;
  @Input() isUppercase?: boolean = false;
  @Input() isStripSpaces?: boolean = false;
  @Input() isLoadNumberField?: boolean = false;
  @Input() hintText?: string;
}
